import React from 'react';
import { contactInfo } from '@/config/config';
import styles from './index.module.scss';
import { Map, InfoWindow } from 'react-amap';
const AMapKey = "8b5755efd36a2c1ffeb1b74b9f042631";

export default function Index() {
  const position = {
    longitude: 120.19419,
    latitude: 30.19922
  }
  return (
    <div>
      <div className={`${styles.banner} ${styles.top_banner}`}>
        <img
          className={styles.banner_img}
          src="/images/top_banner.jpg"
          alt="banner"
        />
      </div>
      <div className={styles.contact_container}>
        <div className={styles.left_border}>
          <div className={styles.border_content}></div>
        </div>
        <div className={styles.content}>
          {
            contactInfo.map(item => (
              <div className={styles.content_container} key={item.key}>
                <div className={styles.title}>{item.title}</div>
                <div className={styles.desc}>{item.value}</div>
              </div>
            ))
          }
        </div>
        <div className={styles.right_border}>
          <div className={styles.border_content}></div>
        </div>
      </div>
      <div className={styles.map_container}>
        {/* <img src="/images/contact/contact.png" alt="" /> */}
        <Map
          zoom={16}
          amapkey={AMapKey}
          center={position}
        >
          <InfoWindow
            position={position}
            visible={true}
            isCustom
          >
            <span style={{ fontSize: 18, padding: '10px 40px', fontWeight: 'bold', display: 'block' }}>博风创意大厦</span>
          </InfoWindow>
        </Map>
      </div>
      <div className={styles.app_footer}>
          <div className={styles.app_img_container}>
            <img src="/images/logo.png" alt=""/>
          </div>
          <div className={styles.app_info_container}>
            <div className={styles.app_info}>
              <div>杭州雅集茶具有限公司</div>
              <a href="http://beian.miit.gov.cn" target="_black" style={{ color: 'rgba(0, 0, 0, .65)' }}>浙ICP备11028005号-2</a>
            </div>
            <div className={styles.app_info}>
              <div>雅集专线:0571-86551555</div>
              <div>浙公网安备 33010802004971号</div>
            </div>
          </div>
        </div>
    </div>
  )
}
